"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.chunk = void 0;
const ArraysError_1 = require("./ArraysError");
const errorCodes_1 = require("./errorCodes");
const chunk = (array, chunkSize) => {
    if (chunkSize <= 0) {
        throw new ArraysError_1.ArraysError({
            code: errorCodes_1.ErrorCodes.CHUNKSIZE_MUST_BE_GREATER_THAN_ZERO,
            message: "Chunk size must be greater than or equal to zero",
            payload: { chunkSize },
        });
    }
    if (!array || !Array.isArray(array)) {
        return [];
    }
    const chunks = [];
    for (let i = 0; i < array.length; i += chunkSize) {
        chunks.push(array.slice(i, i + chunkSize));
    }
    return chunks;
};
exports.chunk = chunk;
//# sourceMappingURL=chunk.js.map